module.exports = "/images/Panama.png?9f62c0bd523380ae81fab0d760ea1255";